// ══════════════════════════════════════════════════════════════════════════════════════════════════════════════════
//  t478 (26-oct-2026) · LO QUE HACE FALTA EN TODA LA APP CON VARIAS CUENTAS ABIERTAS EN EL DISPOSITIVO (como Gmail)
// ══════════════════════════════════════════════════════════════════════════════════════════════════════════════════
//
//  Montado una vez en App (junto al registro del móvil). Sin cuentas dormidas, casi no hace nada. Con ellas
//  (utils/cuentasDelDispositivo):
//   · UNA PESTAÑA, UNA CUENTA: si otra pestaña pasa a otra cuenta, esta se recarga con la de ahora (services/api lo mira
//     también antes de cada petición: aquí es para no esperar a la siguiente).
//   · LAS DORMIDAS NO CADUCAN POR DORMIR: su sesión se renueva con su propio token cada 45 minutos y al volver a la app,
//     dentro de su techo de 7 días (el servidor no lo alarga); y su nombre («Cuenta de Biango»), si no lo traía.
//   · EL AVISO DE OTRA CUENTA, EN EL NAVEGADOR: el service worker (public/sw.js) pregunta de qué cuenta es esta pestaña
//     antes de callar un aviso, y al pulsar uno de otra cuenta, aquí se pasa a ella (/cambiar-cuenta) y se abre lo suyo. En
//     el panel de plataforma, que no monta los avisos de la clínica, también se abre el de esta cuenta. Y una ventana nueva
//     abierta desde un aviso trae su cuenta en la dirección (`biango_cuenta`): si es otra, se pasa a ella.
//  En el móvil el toque lo atiende push/registrarPush (el mismo /cambiar-cuenta).
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  cambioLaCuentaPorDebajo, cuentaActiva, hayOtrasCuentas, renovarLasDormidas, ponerAlDiaLosNombres, rutaParaAbrirAviso,
} from '../utils/cuentasDelDispositivo'

const CADA_MS = 45 * 60 * 1000

export default function CuentasGlobales() {
  const navigate = useNavigate()

  // Una ventana abierta desde un aviso de otra cuenta (…?biango_cuenta=ID): se pasa a ella y se abre lo pedido.
  useEffect(() => {
    try {
      const u = new URL(window.location.href)
      const c = u.searchParams.get('biango_cuenta')
      if (!c) return
      u.searchParams.delete('biango_cuenta')
      const ruta = u.pathname + (u.search || '') + (u.hash || '')
      const otra = rutaParaAbrirAviso(c, ruta)
      if (otra) window.location.replace(otra)
      else window.history.replaceState(null, '', ruta)
    } catch (_) { /* sin dirección que leer */ }
  }, [])

  // Otra pestaña ha cambiado de cuenta: esta se recarga con la de ahora.
  useEffect(() => {
    if (typeof window === 'undefined' || !window.addEventListener) return undefined
    const oir = (e) => {
      if (!e || (e.key !== 'user' && e.key !== 'token')) return
      if (cambioLaCuentaPorDebajo({ siempre: true })) { try { window.location.reload() } catch (_) { /* sin ventana */ } }
    }
    window.addEventListener('storage', oir)
    return () => window.removeEventListener('storage', oir)
  }, [])

  // Las dormidas: renovar su sesión y su nombre, cada 45 minutos y al volver a la app.
  useEffect(() => {
    let ultima = 0
    const hacer = () => {
      if (!hayOtrasCuentas()) return
      ultima = Date.now()
      renovarLasDormidas().catch(() => {})
      ponerAlDiaLosNombres().catch(() => {})
    }
    hacer()
    const reloj = setInterval(hacer, CADA_MS)
    const alVolver = () => { if (document.visibilityState === 'visible' && Date.now() - ultima > 5 * 60 * 1000) hacer() }
    document.addEventListener('visibilitychange', alVolver)
    return () => { clearInterval(reloj); document.removeEventListener('visibilitychange', alVolver) }
  }, [])

  // El service worker: de qué cuenta es esta pestaña, y abrir el aviso pulsado.
  useEffect(() => {
    const sw = typeof navigator !== 'undefined' && navigator.serviceWorker
    if (!sw || !sw.addEventListener) return undefined
    const oir = (event) => {
      const d = (event && event.data) || {}
      if (d.type === 'cuenta-de-la-pestana') {
        const a = cuentaActiva()
        try { event.ports && event.ports[0] && event.ports[0].postMessage({ cuenta: a ? a.id : null }) } catch (_) { /* sin canal */ }
        return
      }
      if (d.type === 'navigate' && d.ruta) {
        const otra = rutaParaAbrirAviso(d.cuenta, d.ruta)
        if (otra) { navigate(otra); return }
        // El panel de plataforma no monta los avisos de la clínica (hooks/useNotifications): allí se abre aquí.
        if (/^\/superadmin(\/|$)/.test(window.location.pathname) && /^\/[^/\\]/.test(String(d.ruta))) navigate(d.ruta)
      }
    }
    sw.addEventListener('message', oir)
    return () => sw.removeEventListener('message', oir)
  }, [navigate])

  return null
}
